export default __webpack_public_path__ + "static/media/tech1-thumb-0.be800438.png";